//
//
//
//
//
//
//
//

export default {
    props: {
        n: {
            type: [Number, String],
            default: 6,
        },
    },
};
